import styled from 'styled-components'
import { getStepContentContainerStyles } from '../style'
import { StepperSize } from '../type'

interface StyledStepContentContainerProps {
    size?: StepperSize
}

const StyledStepContentContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['size'].includes(prop)
})<StyledStepContentContainerProps>(({ theme, size = 'md' }) =>
    getStepContentContainerStyles({ theme, size })
)

export default StyledStepContentContainer
